// Site configuration — detects which domain we're on from hostname
// Single codebase deployed to N domains via Vercel

const DOMAINS = {
  auto: 'https://carsbikesprices.com',
  coupon: 'https://metromandi.com',
  finance: 'https://yourmoneywise.net',
  admin: 'https://allmarketingmixed.com',
  dgtg: 'https://www.dgtg.in',
  devmob: 'https://devmob.co',
  travel: 'https://woketraveler.com',
  tech: 'https://tech-n-ai-talks.com',
  games: 'https://www.gamesnfans.tv',
  vikas: 'https://www.vikasifications.com',
};

function detectSiteId() {
  if (typeof window === 'undefined') return 'all';
  const host = window.location.hostname;
  if (host.includes('carsbikesprices')) return 'auto';
  if (host.includes('metromandi')) return 'coupon';
  if (host.includes('yourmoneywise')) return 'finance';
  if (host.includes('allmarketingmixed')) return 'admin';
  if (host.includes('dgtg')) return 'dgtg';
  if (host.includes('gamesnfans')) return 'games';
  if (host.includes('vikasifications')) return 'vikas';
  if (host.includes('devmob')) return 'devmob';
  if (host.includes('woketraveler')) return 'travel';
  if (host.includes('tech-n-ai-talks')) return 'tech';
  return 'all'; // localhost / preview = show everything
}

const SITE_ID = detectSiteId();
const IS_MULTI_DOMAIN = SITE_ID !== 'all';

export const siteConfig = {
  siteId: SITE_ID,
  isMultiDomain: IS_MULTI_DOMAIN,

  showAutoRoutes: SITE_ID === 'auto' || SITE_ID === 'all',
  showCouponRoutes: SITE_ID === 'coupon' || SITE_ID === 'all',
  showFinanceRoutes: SITE_ID === 'finance' || SITE_ID === 'all',
  showAdminRoutes: SITE_ID === 'admin' || SITE_ID === 'all',
  showDgtgRoutes: SITE_ID === 'dgtg' || SITE_ID === 'all',
  showGamesRoutes: SITE_ID === 'games' || SITE_ID === 'all',
  showVikasRoutes: SITE_ID === 'vikas' || SITE_ID === 'all',
  showDevmobRoutes: SITE_ID === 'devmob' || SITE_ID === 'all',
  showTravelRoutes: SITE_ID === 'travel' || SITE_ID === 'all',
  showTechRoutes: SITE_ID === 'tech' || SITE_ID === 'all',

  defaultRoute: SITE_ID === 'coupon' ? '/coupons' : SITE_ID === 'admin' ? '/admin' : SITE_ID === 'finance' ? '/finance' : SITE_ID === 'dgtg' ? '/dgtg' : SITE_ID === 'games' ? '/games' : SITE_ID === 'vikas' ? '/vikas' : SITE_ID === 'devmob' ? '/devmob' : SITE_ID === 'travel' ? '/travel' : SITE_ID === 'tech' ? '/tech' : '/auto',

  autoUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'auto'
    ? `${DOMAINS.auto}${path || '/auto'}`
    : path || '/auto',

  couponUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'coupon'
    ? `${DOMAINS.coupon}${path || '/coupons'}`
    : path || '/coupons',

  financeUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'finance'
    ? `${DOMAINS.finance}${path || '/finance'}`
    : path || '/finance',

  adminUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'admin'
    ? `${DOMAINS.admin}${path || '/admin'}`
    : path || '/admin',

  dgtgUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'dgtg'
    ? `${DOMAINS.dgtg}${path || '/dgtg'}`
    : path || '/dgtg',

  gamesUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'games'
    ? `${DOMAINS.games}${path || '/games'}`
    : path || '/games',

  devmobUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'devmob'
    ? `${DOMAINS.devmob}${path || '/devmob'}`
    : path || '/devmob',

  travelUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'travel'
    ? `${DOMAINS.travel}${path || '/travel'}`
    : path || '/travel',

  techUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'tech'
    ? `${DOMAINS.tech}${path || '/tech'}`
    : path || '/tech',

  vikasUrl: (path = '') => IS_MULTI_DOMAIN && SITE_ID !== 'vikas'
    ? `${DOMAINS.vikas}${path || '/vikas'}`
    : path || '/vikas',

  autoLabel: 'CarsbikesPrices',
  couponLabel: 'MetroMandi',
  financeLabel: 'YourMoneyWise',
  adminLabel: 'AllMarketingMixed',
  dgtgLabel: 'DGTG',
  gamesLabel: 'GamesNFans',
  vikasLabel: 'Vikasifications',
  devmobLabel: 'DevMob',
  travelLabel: 'WokeTraveler',
  techLabel: 'Tech-N-AI Talks',
};

export default siteConfig;
